module.exports = __webpack_public_path__ + "img/my-img.c4d21701.png";